import { useNavigate } from 'react-router-dom';
import CustomButton from '../reusable/CustomButton';
import PageHeader from '../reusable/PageHeader';
import Panel from '../reusable/Panel';
import useUserDetails from '../hooks/useUserDetails';
import { getRoleHomePath } from '../district-selection/districtSelectionUtils';
import { XQ_INFO_EMAIL } from '../../constants';
import HelpIllustration from '../assets/district-selection-illustration.png';

import './Help.css';

const Help = () => {
  const navigate = useNavigate();
  const {
    userDetails: { data: userDetails },
  } = useUserDetails();

  return (
    <>
      <PageHeader title="Help" />
      <div className="main-content">
        <Panel className="help-panel">
          <div className="help-panel-content">
            <div className="help-panel-details">
              <p className="help-panel-description">For any questions, please email {XQ_INFO_EMAIL}</p>
              <CustomButton
                variant="primary"
                size="medium"
                buttonText="Back to home page"
                buttonAction={() => navigate(getRoleHomePath(userDetails?.role ?? ''))}
              />
            </div>
            <img src={HelpIllustration} alt="" className="help-illustration" aria-hidden="true" />
          </div>
        </Panel>
      </div>
    </>
  );
};

export default Help;
